export default __webpack_public_path__ + "static/media/white_queen.4ac02447.png";